import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { BsFillExclamationTriangleFill } from 'react-icons/bs';

const LabelValue = ({ label, value, last, alert, className, testID = '' }) => (
  <div
    data-testid={testID}
    className={`d-flex flex-row align-items-center justify-content-between ${
      last ? 'mb-0' : 'mb-3'
    } ${className}`}
  >
    <span className="subtitle d-flex justify-content-center mr-2">
      <span>{label}</span>
      {alert ? (
        <Tooltip title={alert}>
          <span className="ml-2 icon-red">
            <BsFillExclamationTriangleFill />
          </span>
        </Tooltip>
      ) : null}
    </span>
    <span>
      <b>{value}</b>
    </span>
  </div>
);

LabelValue.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  last: PropTypes.bool,
  alert: PropTypes.string,
  className: PropTypes.string,
};

LabelValue.defaultProps = {
  last: false,
  alert: undefined,
  className: '',
};

export default LabelValue;
